import { Toastr } from 'components/global/Toastr'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'

const initialState = {
  fetching: false,
  fetching_employess: false,
  cr_fetching: false,
  downloading: false,
  sending: false,
  payment_configurations: [],
  sending_data: {},
  employees: [],
  pagination: {},
  stats: {},
  tracking_stats: {},
  payment_transfers: {
    pagination: {},
    payment_transfers: [],
  },
  payment_transactions: {},
  employees_without_cr: {},
  // I wrote the shape of res to avoid condition statments in UI
  salary_details: {
    additions: {
      breakdown: [],
    },
    earnings: {
      breakdown: [],
    },
    deductions: {
      breakdown: [],
    },
  },
  commercial_registration_families: [],
  payrun_employees: [],
  payrun_employees_fetching: false,
}

export default function reducer(state = initialState, action) {
  const { payload } = action
  switch (action.type) {
    case actions.PAYRUN_EMPLOYEE_LOAD_PENDING: {
      return {
        ...state,
        payrun_employees_fetching: true,
      }
    }

    case actions.COMMERCIAL_REGISTRATION_FAMILIES_LOAD_PENDING: {
      return {
        ...state,
        cr_fetching: true,
      }
    }

    case actions.PAYRUN_EMPLOYEE_LOAD_FULFILLED:
      return {
        ...state,
        payrun_employees: payload.data.data.payrun_employees,
        payrun_employees_fetching: false,
      }

    case actions.COMMERCIAL_REGISTRATION_FAMILIES_LOAD_FULFILLED:
      return {
        ...state,
        commercial_registration_families: payload.data.data.commercial_registration_families,
        cr_fetching: false,
      }

    case actions.PAYRUN_EMPLOYEE_LOAD_REJECTED:
      return {
        ...state,
        payrun_employees_fetching: false,
      }

    case actions.COMMERCIAL_REGISTRATION_FAMILIES_LOAD_REJECTED:
      return {
        ...state,
        cr_fetching: false,
      }
    case actions.PAYMENT_WPS_DOWNLOAD_PENDING:
    case actions.PAYMENT_PROCESSING_DOWNLOAD_PENDING: {
      return {
        ...state,
        downloading: true,
      }
    }
    case actions.PAYMENT_WPS_DOWNLOAD_FULFILLED:
    case actions.PAYMENT_WPS_DOWNLOAD_REJECTED:
    case actions.PAYMENT_PROCESSING_DOWNLOAD_FULFILLED:
    case actions.PAYMENT_PROCESSING_DOWNLOAD_REJECTED:
      return {
        ...state,
        downloading: false,
      }

    case actions.PAYMNET_TRACKING_LOAD_PENDING:
    case actions.PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_PENDING:
      return {
        ...state,
        fetching: true,
        fetching_employess: true,
      }

    case actions.EMPLOYEE_SALARY_DETAILS_PENDING:
    case actions.PAYMNET_TRANSFER_STATS_PENDING:
    case actions.PYARUN_EMPLOYEES_WITHOUT_CR_PENDING:
    case actions.PAYMNET_TRANSACTIONS_LOAD_PENDING:
      return {
        ...state,
        fetching: true,
      }

    case actions.PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_FULFILLED: {
      const { previous_page } = action.payload.data.data.pagination

      return {
        ...state,
        employees: [
          ...new Set([...(previous_page ? state.employees : []), ...payload.data.data.employees]),
        ],
        pagination: payload.data.data.pagination,
        fetching: false,
        fetching_employess: false,
      }
    }

    case actions.PAYMNET_PROCESSING_PAYROLL_STATS_FULFILLED:
      return {
        ...state,
        ...payload.data.data,
        fetching: false,
      }

    case actions.PAYMNET_TRACKING_LOAD_FULFILLED: {
      const { previous_page } = payload.data.data.pagination

      return {
        ...state,
        payment_transfers: {
          pagination: payload.data.data.pagination,
          payment_transfers: [
            ...new Set([
              ...(previous_page ? state.payment_transfers.payment_transfers : []),
              ...payload.data.data.payment_transfers,
            ]),
          ],
        },
        fetching: false,
        fetching_employess: false,
      }
    }

    case actions.PAYMNET_TRANSFER_STATS_FULFILLED:
      return {
        ...state,
        tracking_stats: payload.data.data.stats,
        fetching: false,
      }

    case actions.PAYMNET_TRANSACTIONS_LOAD_FULFILLED: {
      const { previous_page } = payload.data.data.pagination
      return {
        ...state,
        payment_transactions: {
          pagination: payload.data.data.pagination,
          payment_transactions: [
            ...new Set([
              ...(previous_page ? state.payment_transactions?.payment_transactions : []),
              ...payload.data.data.payment_transactions,
            ]),
          ],
        },
        fetching: false,
      }
    }

    case actions.EMPLOYEE_SALARY_DETAILS_FULFILLED:
      return {
        ...state,
        salary_details: payload.data.data,
        fetching: false,
      }

    case actions.PYARUN_EMPLOYEES_WITHOUT_CR_FULFILLED:
      return {
        ...state,
        employees_without_cr: payload.data.data,
        fetching: false,
      }

    case actions.PAYMNET_PROCESSING_PAYROLL_EMPLOYEES_REJECTED:
    case actions.PAYMNET_TRACKING_LOAD_REJECTED:
      return {
        ...state,
        fetching: false,
        fetching_employess: false,
      }

    case actions.EMPLOYEE_SALARY_DETAILS_REJECTED:
    case actions.PAYMNET_TRANSFER_STATS_REJECTED:
    case actions.PYARUN_EMPLOYEES_WITHOUT_CR_REJECTED:
    case actions.PAYMNET_TRANSACTIONS_LOAD_REJECTED:
      return {
        ...state,
        fetching: false,
      }

    case actions.PAYMENT_SEND_TO_BANK_PENDING:
      return {
        ...state,
        sending: true,
      }

    case actions.PAYMENT_SEND_TO_BANK_FULFILLED: {
      const vals = payload.data.data
      if (action?.payload?.data?.message) Toastr.success(payload.data.message)

      return {
        ...state,
        sending_data: vals || state.sending_data,
        sending: false,
      }
    }

    case actions.PAYMENT_SEND_TO_BANK_REJECTED:
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        sending: false,
      }

    case actions.CANCEL_PAYMENT_PENDING:
      return {
        ...state,
        sending: true,
      }

    case actions.CANCEL_PAYMENT_FULFILLED:
      if (payload.data.message) {
        Toastr.success(payload.data.message)
      }
      return {
        ...state,
        ...payload.data.data,
        sending: false,
      }

    case actions.CANCEL_PAYMENT_REJECTED:
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        sending: false,
      }
    case actions.RESET_PAYMENTPROCESSING: {
      return initialState
    }
    default:
      return state
  }
}
